<template>
    <PlanbordGridCell :header="header" class="function-cell" info>
        <slot></slot>
    </PlanbordGridCell>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import PlanbordGridCell from '@/components/Planbord/PlanbordGridCell.vue';

    @Component({
        components: {
            PlanbordGridCell,
        },
    })
    export default class PlanbordFunctionCell extends Vue {
        @Prop({type: Boolean}) public header!: boolean;
    }
</script>

<style lang="scss" scoped>
    .function-cell {
        display: var(--show-function-cell, block);
    }
</style>
